import React, { useEffect, useRef, useState } from 'react';

function ParallaxBlock({ backgroundImage, foregroundImageSrc, textContent, number }) {
	const blockRef = useRef(null);
	const foregroundImageRef = useRef(null);
	const textRef = useRef(null);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth <= 767);
		};
		checkMobile();
		window.addEventListener('resize', checkMobile);
		return () => window.removeEventListener('resize', checkMobile);
	}, []);

	const handleScroll = () => {
		if (!blockRef.current) return;

		const blockTop = blockRef.current.getBoundingClientRect().top;
		const windowHeight = window.innerHeight;
		
		// Check if the block is within the viewport
		if (blockTop < windowHeight && blockTop > -windowHeight) {
			const scrollY = window.pageYOffset;
			const imageSpeed = 0.3; // Adjust as needed

			if (foregroundImageRef.current) {
				const translateY = (blockTop - windowHeight) * imageSpeed;
				foregroundImageRef.current.style.transform = `translateY(${translateY}px)`;
			}

			// Removed text translation to keep it fixed
		}
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const parallaxStyle = {
		backgroundImage: `url(${backgroundImage})`,
		backgroundSize: 'cover', // Added to make the background cover the container while maintaining aspect ratio
		backgroundRepeat: 'no-repeat', // Added to prevent tiling
		maxWidth: '100%',
		backgroundPosition: 'center',
		backgroundAttachment: 'scroll', 
		position: 'relative',
		height: '60vh',
		overflow: 'hidden',
	};

	const getForegroundStyle = () => {
		let baseStyle = {
			position: 'absolute',
			height: 'auto',
			maxWidth: '100vw',
			zIndex: 2,
		};

		if (number === 'one') {
			baseStyle.top = '15vh';
			baseStyle.left = '50%';
			baseStyle.width = '50vh';
			if (isMobile) {
				baseStyle.top = '20vh';
				baseStyle.width = '45vh';
				baseStyle.left = '30%';
			}
		} else if (number === 'two') {
			baseStyle.top = '15vh';
			baseStyle.right = '50%';
			baseStyle.width = '50vh';
			if (isMobile) {
				baseStyle.top = '20vh';
				baseStyle.width = '45vh';
				baseStyle.right = '30%';
			}
		} else if (number === 'three') {
			baseStyle.top = '20vh';
			baseStyle.left = '50%';
			baseStyle.width = '45vh';
			if (isMobile) {
				baseStyle.width = '45vh';
				baseStyle.left = '40%';
			}
		} else if (number === 'four') {
			baseStyle.top = '15vh';
			baseStyle.right = '50%';
			baseStyle.width = '35vh';
		}

		return baseStyle;
	};

	const textStyle = {    
		position: 'absolute',
		top: '30%',
		left: '50%',
		transform: 'translateX(-50%)',
		color: '#FFFFFF',
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
		fontWeight: 900,
		zIndex: 3,
		fontSize: isMobile ? '7vh' : '9vh',
		width: isMobile ? '80%' : '45%',
		textAlign: 'center',
		textShadow: '2px 2px 2px var(--black)',
		whiteSpace: 'pre-line',
		wordBreak: 'break-word',
	};

	return (
		<div ref={blockRef} style={parallaxStyle}>
			<img ref={foregroundImageRef} src={foregroundImageSrc} alt="Foreground" style={getForegroundStyle()} />
			<div ref={textRef} style={textStyle}>
				{textContent}
			</div>
		</div>
	);
}

export default ParallaxBlock;